import React, { createContext, useContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

const NotificationContext = createContext(null);

export const NotificationProvider = ({ children }) => {
  const [isFirstLoginSession, setIsFirstLoginSession] = useState({
    overview: true,
    vehicleMonitoring: true,
    broadcast: true,
    safetyAndAnomalyMonitorSafety: true,
    safetyAndAnomalyMapView: true,
    dmsVideoMode: true,
    dmsMapMode: true,
    superAdminCompaniesOverview: true,
  });

  const resetOnLogout = () => {
    setIsFirstLoginSession(prevState => ({
      ...prevState,
      overview: true,
      vehicleMonitoring: true,
      broadcast: true,
      safetyAndAnomalyMonitorSafety: true,
      safetyAndAnomalyMapView: true,
      dmsVideoMode: true,
      dmsMapMode: true,
      superAdminCompaniesOverview: true,
    }));
  };

  const cancelOverviewNotification = () => {
    setIsFirstLoginSession(prevState => ({
      ...prevState,
      overview: false,
    }));
  };

  const cancelVehicleMonitoringNotification = () => {
    setIsFirstLoginSession(prevState => ({
      ...prevState,
      vehicleMonitoring: false,
    }));
  };

  const cancelBroadcastNotification = () => {
    setIsFirstLoginSession(prevState => ({
      ...prevState,
      broadcast: false,
    }));
  };

  const cancelMonitorSafetyNotification = () => {
    setIsFirstLoginSession(prevState => ({
      ...prevState,
      safetyAndAnomalyMonitorSafety: false,
    }));
  };

  const cancelMapViewNotification = () => {
    setIsFirstLoginSession(prevState => ({
      ...prevState,
      safetyAndAnomalyMapView: false,
    }));
  };

  const cancelDmsVideoModeNotification = () => {
    setIsFirstLoginSession(prevState => ({
      ...prevState,
      dmsVideoMode: false,
    }));
  };
  const cancelDmsMapModeNotification = () => {
    setIsFirstLoginSession(prevState => ({
      ...prevState,
      dmsMapMode: false,
    }));
  };

  const cancelSuperAdminCompaniesOverviewNotification = () => {
    setIsFirstLoginSession(prevState => ({
      ...prevState,
      superAdminCompaniesOverview: false,
    }));
  };

  const contextValue = useMemo(
    () => ({
      isFirstLoginSession,
      resetOnLogout,
      cancelOverviewNotification,
      cancelVehicleMonitoringNotification,
      cancelBroadcastNotification,
      cancelMonitorSafetyNotification,
      cancelMapViewNotification,
      cancelDmsVideoModeNotification,
      cancelDmsMapModeNotification,
      cancelSuperAdminCompaniesOverviewNotification,
    }),
    [isFirstLoginSession]
  );

  return (
    <NotificationContext.Provider value={contextValue}>
      {children}
    </NotificationContext.Provider>
  );
};

NotificationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useNotification = () => useContext(NotificationContext);
